<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<label class="custom-checkbox"
[ngClass]="{
  'position-left': position === 'left',
  'position-right': position === 'right',
  'disabled': disabled,
  'selected': checked,
  'partial': indeterminate
  }"
  (click)="toggleChecked()">
    <!-- Checkbox container for positioning the icon relative to the checkbox -->
    <span class="checkbox-container">
    <input type="checkbox"
      [disabled]="disabled"
      [checked]="checked"
      [indeterminate]="indeterminate" />
    <!-- The check icon, only visible when checked -->
    <hyperkit-icon *ngIf="checked && !indeterminate" color="inherit" size="small" icon="check" class="check-icon">
    </hyperkit-icon>
    <!-- The minus icon, only visible when indeterminate -->
    <hyperkit-icon *ngIf="indeterminate" color="inherit" size="small" icon="minus" class="minus-icon">
    </hyperkit-icon>
  </span>
<hyperkit-typography variant="body1" color="inherit" *ngIf="label" (click)="$event.stopPropagation(); toggleChecked()">{{ label }}</hyperkit-typography>
</label>